import { object, string } from "yup";
import type { VendorCompany } from "~/models/VendorCompany";

export type VendorUser = {
	email: string;
	hasPassword: boolean;
	id: number;
	name: string;
	seq: number;
	tel: string;
};
export type VendorUserWithCompany = VendorUser & {
	vendorCompany: VendorCompany;
};

export type VendorUserSelfUpdateParam = {
	email: string;
	name: string;
	tel: string;
};

export type VendorUserSettingParam = VendorUserSelfUpdateParam & {
	// password: string;
};

export type VendorUserUpdatePasswordParam = {
	confirmPassword: string;
	newPassword: string;
	oldPassword: string;
};

export const vendorUserValidationScheme = object().shape({
	email: string()
		.required("メールアドレスを入力してください")
		.email("メールアドレスの形式を確認してください"),
	name: string().required("氏名を入力してください"),
	tel: string().required("電話番号を入力してください")
});

export const vendorUserPasswordValidationSchema = object().shape({
	confirmPassword: string()
		.test(
			"passwordConfirm",
			"パスワードが一致しません",
			function testConfirmPassword(value: string | undefined) {
				const { newPassword } = this.parent;
				if (newPassword === "" || newPassword === null) {
					return true;
				}
				return value === newPassword;
			}
		)
		.max(255, "255文字以内で設定してください"),
	newPassword: string().max(255, "255文字以内で設定してください"),
	oldPassword: string().when("$hasPassword", {
		is: true,
		// biome-ignore lint/suspicious/noThenProperty: <Yupのwhen/then構文のため>
		then: (schema) => schema.required("現在のパスワードを入力してください")
	})
});

export const convertToComboBoxOption = (
	vendorUser: VendorUser
): { label: string; value: string } => ({
	label: vendorUser.name,
	value: String(vendorUser.id)
});
